/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventToolMeasureFromJSON(json) {
    return StreemApiAnalyticEventToolMeasureFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventToolMeasureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'elementId': !exists(json, 'element_id') ? undefined : json['element_id'],
        'lengthMeters': !exists(json, 'length_meters') ? undefined : json['length_meters'],
    };
}
export function StreemApiAnalyticEventToolMeasureToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'element_id': value.elementId,
        'length_meters': value.lengthMeters,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventToolMeasure.js.map